import { combineReducers } from 'redux';
import { Actions, ActionTypes } from './actions';
import { channels as channelInfo } from './constants';
import { IChannel, IContracts } from './types';

export const defaultChannels = (state = channelInfo as IChannel[]) => {
	return state;
};

export const contracts = (state = {} as { [customerId: string]: IContracts }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.CUSTOMER_CONTRACTS_RECEIVE:
		case ActionTypes.UPDATE_CONTRACTS_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.contracts };
		default:
			return state;
	}
};

export const terms = (state = {} as { [termType: string]: IContracts }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.GET_TERMS_RECEIVE:
		case ActionTypes.UPDATE_TERMS_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.contracts };
		default:
			return state;
	}
};

export interface IChannelsState {
	defaultChannels: ReturnType<typeof defaultChannels>;
	contracts: ReturnType<typeof contracts>;
	terms: ReturnType<typeof terms>;
}

const channels = combineReducers<IChannelsState>({
	contracts,
	defaultChannels,
	terms
});

export default channels;
